import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/meeting/envo-logo-text.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "head" }
const _hoisted_3 = { class: "h_l" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "txt" }
const _hoisted_9 = { class: "qrcodeBox" }
const _hoisted_10 = {
  class: "txt",
  style: {"text-align":"center"}
}

import { liveShareDetail } from '@/api/live';
import { QrcodeSvg } from 'qrcode.vue';
import { onMounted, ref } from 'vue';
import useDownloadApp from '@/hooks/useDownloadApp';
import { useRoute } from 'vue-router';
import useOpenApp from '@/hooks/useOpenApp';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const liveDetail = ref();
const qrcodeValue = ref('');
// 1947480998093828121
const route = useRoute();
const { openApp } = useOpenApp();
const { downloadApp } = useDownloadApp();
const liveShareDetailFun = async () => {
  try {
    let res = await liveShareDetail({
      id: route.query.id,
    });
    liveDetail.value = res.value.result;
  } catch (error) {}
};

onMounted(() => {
  qrcodeValue.value = window.location.href;
});
liveShareDetailFun();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Envo直播')), 1)
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args))),
        class: "h_r"
      }, _toDisplayString(_ctx.$t('打开看看')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: "live-bg",
        src: liveDetail.value?.roomBg
      }, null, 8, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(liveDetail.value?.displayName || '-') + " ", 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('直播')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(liveDetail.value?.roomTitle || '-'), 1),
      _createElementVNode("div", _hoisted_9, [
        (qrcodeValue.value)
          ? (_openBlock(), _createBlock(_unref(QrcodeSvg), {
              key: 0,
              class: "qrcode",
              value: qrcodeValue.value,
              background: 'transparent'
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('请使用手机端「Envo App」扫码加入')), 1),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args))),
        class: "btnBox"
      }, _toDisplayString(_ctx.$t('观看直播')), 1)
    ])
  ]))
}
}

})